module.exports = __webpack_public_path__ + "media/images/athletes/1004-24b5b005c156768f9f911e75c9e21d27.png";